import React, { useEffect, useState } from "react";
import { differenceInSeconds, parseISO } from "date-fns";

interface CountDownProps {
  to: string;
  onFinish?: () => void;
}

export const CountDown = ({ to, onFinish }: CountDownProps) => {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    const update = () => {
      const diff = differenceInSeconds(parseISO(to), new Date());
      if (diff <= 0) {
        setSecondsLeft(0);
        onFinish?.();
      } else {
        setSecondsLeft(diff);
      }
    };

    update();

    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [to, onFinish]);

  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours} hora, ${minutes} min e ${secs} seg`;
  };

  return <span>{formatTime(secondsLeft)}</span>;
};